/**
 * Torso outfit textures: alien-mythic-2
 */
export function drawTorso_steampunk_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 41. ÁO GHI LÊ DA THUỘC ĐÍNH BÁNH RĂNG VÀ ĐAI ĐỒNG THAU (STEAM-COG - MALE)
  ctx.fillStyle = mainColor || '#78350f';
  ctx.fillRect(0, 0, size, size);

  // Áo sơ mi trắng ngà bên trong
  ctx.fillStyle = '#fef3c7';
  ctx.beginPath();
  ctx.moveTo(size * 0.35, 0);
  ctx.lineTo(size * 0.5, size * 0.22);
  ctx.lineTo(size * 0.65, 0);
  ctx.closePath();
  ctx.fill();

  // Cà vạt da sẫm
  ctx.fillStyle = '#451a03';
  ctx.beginPath();
  ctx.moveTo(size * 0.48, size * 0.1);
  ctx.lineTo(size * 0.52, size * 0.1);
  ctx.lineTo(size * 0.54, size * 0.35);
  ctx.lineTo(size * 0.5, size * 0.4);
  ctx.lineTo(size * 0.46, size * 0.35);
  ctx.closePath();
  ctx.fill();

  // Bánh răng đồng ngực áo
  ctx.fillStyle = '#ca8a04';
  ctx.beginPath();
  ctx.arc(size * 0.3, size * 0.35, size * 0.05, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#78350f';
  ctx.beginPath();
  ctx.arc(size * 0.3, size * 0.35, size * 0.02, 0, Math.PI * 2);
  ctx.fill();

  // Đai da đồng thau
  ctx.fillStyle = '#451a03';
  ctx.fillRect(0, size * 0.68, size, size * 0.1);
  ctx.fillStyle = '#ca8a04';
  ctx.fillRect(size * 0.42, size * 0.69, size * 0.16, size * 0.08);
}

export function drawTorso_steampunk_female(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 42. ÁO CORSET CƠ KHÍ NẸP ĐỒNG THAU VÀ REN ĐỒNG CỔ (STEAM-COG - FEMALE)
  ctx.fillStyle = mainColor || '#854d0e';
  ctx.fillRect(0, 0, size, size);

  // Cổ áo ren đồng
  ctx.fillStyle = options.skinColor || '#d4a373';
  ctx.beginPath();
  ctx.moveTo(size * 0.32, 0);
  ctx.lineTo(size * 0.5, size * 0.16);
  ctx.lineTo(size * 0.68, 0);
  ctx.closePath();
  ctx.fill();

  // Tấm corset nẹp đồng
  ctx.fillStyle = '#451a03';
  ctx.fillRect(size * 0.25, size * 0.2, size * 0.5, size * 0.45);
  ctx.strokeStyle = '#ca8a04';
  ctx.lineWidth = size * 0.015;
  [0.35, 0.45, 0.55, 0.65].forEach((xPos) => {
    ctx.beginPath();
    ctx.moveTo(size * xPos, size * 0.2);
    ctx.lineTo(size * xPos, size * 0.65);
    ctx.stroke();
  });

  // Đai thắt lưng corset đồng
  ctx.fillStyle = '#ca8a04';
  ctx.fillRect(0, size * 0.65, size, size * 0.08);
}

export function drawTorso_fulgor_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 43. ÁO NẸP ĐIỆN CỰC DẪN DÒNG ION CAO THẾ (VOLTARIA - MALE)
  ctx.fillStyle = mainColor || '#0284c7';
  ctx.fillRect(0, 0, size, size);

  // Thanh nẹp điện cực 2 bên
  ctx.fillStyle = '#0f172a';
  ctx.fillRect(size * 0.15, size * 0.15, size * 0.14, size * 0.5);
  ctx.fillRect(size * 0.71, size * 0.15, size * 0.14, size * 0.5);

  // Lõi năng lượng plasma tròn ở ngực
  ctx.fillStyle = '#38bdf8';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.35, size * 0.07, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.35, size * 0.03, 0, Math.PI * 2);
  ctx.fill();

  // Dây dẫn hồ quang
  ctx.strokeStyle = '#7dd3fc';
  ctx.lineWidth = size * 0.015;
  ctx.beginPath();
  ctx.moveTo(size * 0.22, size * 0.35);
  ctx.lineTo(size * 0.43, size * 0.35);
  ctx.moveTo(size * 0.57, size * 0.35);
  ctx.lineTo(size * 0.78, size * 0.35);
  ctx.stroke();

  // Đai thắt lưng cách điện
  ctx.fillStyle = '#0c4a6e';
  ctx.fillRect(0, size * 0.68, size, size * 0.1);
}

export function drawTorso_fulgor_female(ctx, size, options = {}) {
  // 44. VÁY LỤA SÓNG ĐIỆN TỪ PLASMA XANH DẠ QUANG (VOLTARIA - FEMALE)
  const fulgorFGrad = ctx.createLinearGradient(0, 0, 0, size);
  fulgorFGrad.addColorStop(0, '#0369a1');
  fulgorFGrad.addColorStop(0.5, '#0284c7');
  fulgorFGrad.addColorStop(1, '#38bdf8');
  ctx.fillStyle = fulgorFGrad;
  ctx.fillRect(0, 0, size, size);

  // Cổ áo chữ V cách điện
  ctx.fillStyle = options.skinColor || '#38bdf8';
  ctx.beginPath();
  ctx.moveTo(size * 0.34, 0);
  ctx.lineTo(size * 0.5, size * 0.16);
  ctx.lineTo(size * 0.66, 0);
  ctx.closePath();
  ctx.fill();

  // Sóng điện từ plasma phát sáng
  ctx.strokeStyle = '#ffffff';
  ctx.lineWidth = size * 0.015;
  [0.26, 0.42, 0.56].forEach((yPos) => {
    ctx.beginPath();
    ctx.moveTo(size * 0.2, size * yPos);
    ctx.lineTo(size * 0.4, size * (yPos - 0.03));
    ctx.lineTo(size * 0.6, size * (yPos + 0.03));
    ctx.lineTo(size * 0.8, size * yPos);
    ctx.stroke();
  });

  // Đai thắt eo ion
  ctx.fillStyle = '#075985';
  ctx.fillRect(0, size * 0.64, size, size * 0.08);
  ctx.fillStyle = '#7dd3fc';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.68, size * 0.035, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_astral_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 45. ÁO CHOÀNG DẢI NGÂN HÀ ĐÍNH BỤI SAO VÀ CHÒM SAO (STARDUST-NOVA - MALE)
  ctx.fillStyle = mainColor || '#312e81';
  ctx.fillRect(0, 0, size, size);

  // Cổ áo ánh sao
  ctx.fillStyle = options.skinColor || '#818cf8';
  ctx.beginPath();
  ctx.moveTo(size * 0.35, 0);
  ctx.lineTo(size * 0.5, size * 0.18);
  ctx.lineTo(size * 0.65, 0);
  ctx.closePath();
  ctx.fill();

  // Bản đồ chòm sao thêu chỉ bạc trên ngực áo
  const cPts = [
    [0.3, 0.3],
    [0.5, 0.25],
    [0.7, 0.35],
    [0.45, 0.48],
    [0.65, 0.55]
  ];
  ctx.strokeStyle = 'rgba(199, 210, 254, 0.6)';
  ctx.lineWidth = size * 0.012;
  ctx.beginPath();
  ctx.moveTo(size * cPts[0][0], size * cPts[0][1]);
  for (let p = 1; p < cPts.length; p++) {
    ctx.lineTo(size * cPts[p][0], size * cPts[p][1]);
  }
  ctx.stroke();
  cPts.forEach((pt) => {
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], size * 0.02, 0, Math.PI * 2);
    ctx.fill();
  });

  // Đai thắt lưng tinh tú
  ctx.fillStyle = '#1e1b4b';
  ctx.fillRect(0, size * 0.68, size, size * 0.1);
  ctx.fillStyle = '#a5b4fc';
  ctx.fillRect(size * 0.42, size * 0.69, size * 0.16, size * 0.08);
}

export function drawTorso_astral_female(ctx, size, options = {}) {
  // 46. VÁY DẠ KHÚC TINH VÂN SAO BĂNG THƯỚT THA (STARDUST-NOVA - FEMALE)
  const astralFGrad = ctx.createLinearGradient(0, 0, 0, size);
  astralFGrad.addColorStop(0, '#1e1b4b');
  astralFGrad.addColorStop(0.5, '#3730a3');
  astralFGrad.addColorStop(1, '#6366f1');
  ctx.fillStyle = astralFGrad;
  ctx.fillRect(0, 0, size, size);

  // Cổ áo tinh vân mềm mại
  ctx.fillStyle = options.skinColor || '#818cf8';
  ctx.beginPath();
  ctx.ellipse(size * 0.5, 0, size * 0.22, size * 0.15, 0, 0, Math.PI);
  ctx.fill();

  // Dải sao băng chéo ngực
  ctx.strokeStyle = '#c7d2fe';
  ctx.lineWidth = size * 0.016;
  ctx.beginPath();
  ctx.moveTo(size * 0.2, size * 0.18);
  ctx.lineTo(size * 0.8, size * 0.55);
  ctx.stroke();

  // Bụi sao lấp lánh
  [
    [0.35, 0.35],
    [0.6, 0.28],
    [0.45, 0.5],
    [0.7, 0.45]
  ].forEach((pt) => {
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], size * 0.018, 0, Math.PI * 2);
    ctx.fill();
  });

  // Đai eo tinh vân
  ctx.fillStyle = '#312e81';
  ctx.fillRect(0, size * 0.65, size, size * 0.08);
  ctx.fillStyle = '#c7d2fe';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.69, size * 0.035, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_zephyr_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 47. ÁO PHONG LỮ VẠT LƯỢN SÓNG KHÍ QUYỂN (AETHERIA - MALE)
  ctx.fillStyle = mainColor || '#0284c7';
  ctx.fillRect(0, 0, size, size);

  // Cổ áo lượn mây trắng
  ctx.fillStyle = options.skinColor || '#bae6fd';
  ctx.beginPath();
  ctx.moveTo(size * 0.35, 0);
  ctx.lineTo(size * 0.5, size * 0.16);
  ctx.lineTo(size * 0.65, 0);
  ctx.closePath();
  ctx.fill();

  // Đường sóng mây đối lưu viền trắng
  ctx.strokeStyle = '#f0f9ff';
  ctx.lineWidth = size * 0.02;
  [0.25, 0.42, 0.58].forEach((yPos) => {
    ctx.beginPath();
    ctx.moveTo(size * 0.15, size * yPos);
    ctx.bezierCurveTo(size * 0.35, size * (yPos - 0.04), size * 0.65, size * (yPos + 0.04), size * 0.85, size * yPos);
    ctx.stroke();
  });

  // Đai thắt lưng phong vân
  ctx.fillStyle = '#0369a1';
  ctx.fillRect(0, size * 0.66, size, size * 0.1);
  ctx.fillStyle = '#7dd3fc';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.71, size * 0.04, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_zephyr_female(ctx, size, options = {}) {
  // 48. VÁY LỤA PHONG VÂN BAY BỔNG DẢI LỤA MỎNG (AETHERIA - FEMALE)
  const zephyrFGrad = ctx.createLinearGradient(0, 0, 0, size);
  zephyrFGrad.addColorStop(0, '#0369a1');
  zephyrFGrad.addColorStop(0.5, '#38bdf8');
  zephyrFGrad.addColorStop(1, '#bae6fd');
  ctx.fillStyle = zephyrFGrad;
  ctx.fillRect(0, 0, size, size);

  // Cổ áo cánh mây
  ctx.fillStyle = options.skinColor || '#bae6fd';
  ctx.beginPath();
  ctx.ellipse(size * 0.5, 0, size * 0.22, size * 0.14, 0, 0, Math.PI);
  ctx.fill();

  // Dải lụa mỏng bay uốn lượn
  ctx.strokeStyle = '#ffffff';
  ctx.lineWidth = size * 0.016;
  ctx.beginPath();
  ctx.moveTo(size * 0.2, size * 0.2);
  ctx.bezierCurveTo(size * 0.5, size * 0.35, size * 0.3, size * 0.55, size * 0.8, size * 0.6);
  ctx.stroke();

  // Đai eo lụa trắng
  ctx.fillStyle = '#0284c7';
  ctx.fillRect(0, size * 0.64, size, size * 0.08);
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.68, size * 0.035, 0, Math.PI * 2);
  ctx.fill();
}

export const alien_mythic_2_drawers = {
  steampunk_male: drawTorso_steampunk_male,
  steampunk_female: drawTorso_steampunk_female,
  fulgor_male: drawTorso_fulgor_male,
  fulgor_female: drawTorso_fulgor_female,
  astral_male: drawTorso_astral_male,
  astral_female: drawTorso_astral_female,
  zephyr_male: drawTorso_zephyr_male,
  zephyr_female: drawTorso_zephyr_female
};
